import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";

import { DecimalField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type DecimalInputProps = {
	field: DecimalField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const DecimalInput: React.FC<DecimalInputProps> = (
	props: DecimalInputProps
) => {
	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<Grid item>
			<Typography>{props.field.name}</Typography>
			<ManagedTextField
				id={props.field.name}
				fullWidth
				type="number"
				disabled={
					!props.editable ||
					props.rights[toId(props.field.uuid)][
						InformationRight.WRITE
					] === false
				}
				required={props.field.required}
				value={props.field.value.toString()}
				onUpdate={value => props.onChange(props.field.uuid, value)}
			/>
		</Grid>
	);
};

export default DecimalInput;
